<template>
  <d-layout></d-layout>
</template>

<script>
import DLayout from "@/layout/Layout";
export default {
  components: {
    DLayout
  }
};
</script>
